export const login = (locale) => `/${locale}`;
export const registerSuccess = (locale) => `/${locale}/register/success`;
export const subscription = (locale) => `/${locale}/register-subscription`;
export const dashboard = (locale) => `/${locale}/dashboard`;
export const request = (locale) => `/${locale}/request`;
export const appointments = (locale) => `/${locale}/appointments`;
export const requestDetail = (locale) => `/${locale}/request-detail`;
export const doctor = (locale) => `/${locale}/doctor`;
export const doctorDetail = (locale) => `/${locale}/doctor-detail`;
export const practices = (locale) => `/${locale}/practices`;
export const practicesDetail = (locale) => `/${locale}/practice-detail`;
export const patients = (locale) => `/${locale}/patients`;
export const patientsDetail = (locale) => `/${locale}/patients-detail`;
export const questionnaire = (locale) => `/${locale}/questionnaire`;
export const questionnaireDetail = (locale) =>
  `/${locale}/questionnaire-detail`;
export const products = (locale) => `/${locale}/products`;
export const setting = (locale) => `/${locale}/setting`;
export const doctorDashboard = (locale) => `/${locale}/doctor-dashboard`;
export const doctorAppointments = (locale) => `/${locale}/doctor-appointment`;
export const doctorAppointmentsRequestDetails = (locale) =>
  `/${locale}/doctor-appointment-request-details`;
export const doctorAppointmentsUpcomingDetails = (locale) =>
  `/${locale}/doctor-appointment-upcoming-details`;
export const revenueStream = (locale) => `/${locale}/revenueStream`;
export const otp = (locale) => `/${locale}/otp`;
export const skinAnalyser = (locale) => `/${locale}/skin-analyser`;
export const skinAnalyserDetail = (locale) => `/${locale}/skin-analyser-detail`;
export const scanResult = (locale) => `/${locale}/scan-result`;
export const enterprise = (locale) => `/${locale}/enterprise`;
export const enterpriseDetail = (locale) => `/${locale}/enterprise-detail`;
export const staffDetail = (locale) =>
  `/${locale}/enterprise-detail/staff-detail`;
export const userDetail = (locale) =>
  `/${locale}/enterprise-detail/staff-detail/user-detail`;
export const enterpriseDashboard = (locale) =>
  `/${locale}/enterprise-dashboard`;
export const enterprisePatients = (locale) => `/${locale}/enterprise-patients`;
export const staff = (locale) => `/${locale}/staff`;
export const location = (locale) => `/${locale}/location`;
export const enterpriseProducts = (locale) => `/${locale}/enterprise-products`;
export const leadCapture = (locale) => `/${locale}/leadCapture`;
export const leadCaptureDetail = (locale) => `/${locale}/lead-capture-detail`;
export const setUpPassword = (locale) => `/${locale}/setup-password`;
